import { callNativeMessage } from "@bridge/callNative"
import type { BridgeResponse } from "types/native-bridge"

/*카메라 권한 요청*/
export const requestCameraPermission = (): Promise<
  BridgeResponse<{ isGranted: boolean }>
> =>
  callNativeMessage({
    type: "request",
    handlerName: "requestCameraPermission",
  })

/*카메라 권한 상태*/
export const cameraPermissionStatus = (): Promise<
  BridgeResponse<{ isGranted: boolean }>
> =>
  callNativeMessage({
    type: "request",
    handlerName: "cameraPermissionStatus",
  })

/*위치 권한 요청*/
export const requestLocationPermission = (): Promise<
  BridgeResponse<{ isGranted: boolean; status: string }>
> =>
  callNativeMessage({
    type: "request",
    handlerName: "requestLocationPermission",
  })

/*위치 권한 상태*/
export const locationPermissionStatus = (): Promise<
  BridgeResponse<{ isGranted: boolean; status: string }>
> =>
  callNativeMessage({
    type: "request",
    handlerName: "locationPermissionStatus",
  })

/*네트워크 권한 상태*/
export const networkPermissionStatus = (): Promise<
  BridgeResponse<{ isGranted: boolean }>
> =>
  callNativeMessage({
    type: "request",
    handlerName: "networkPermissionStatus",
  })
